import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { productCompareFlyOutStyles } from "@insite/content-library/Components/ProductCompareFlyOut";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

productCompareFlyOutStyles.carouselDrawer = mergeToNew(productCompareFlyOutStyles.carouselDrawer, {
    cssOverrides: {
        scrim: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        background: none;
                    `,
                    css`
                        background: none;
                    `,
                    css``,
                    css``,
                    css``,
                ])}
        `,
        drawerBody: css`
            background: white;
            margin: 0 auto;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        height: 115px;
                    `,
                    null,
                    null,
                    null,
                    null,
                ])};
        `,
        drawerTitle: css`
            background: white;
            width: 1400px;
            margin-top: 10px;
            width: 100%;
            margin: 0 auto;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            padding: 0 20px;
                        `,
                        null,
                        null,
                        css`
                            max-width: 100%;
                            padding: 0 80px;
                        `,
                    ],
                    "min",
                )};

            [class^="GridOffset"] {
                margin-bottom: 10px;
                padding-top: 7px;
            }
        `,
    },
});

productCompareFlyOutStyles.carouselDrawerContainer = mergeToNew(productCompareFlyOutStyles.carouselDrawerContainer, {
    css: css`
        margin-top: 10px;
        margin: 0 auto;
        background: white;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        display: none;
                    `,
                    css`
                        display: block;
                    `,
                    null,
                    css`
                        max-width: 100%;
                        padding: 0 80px;
                    `,
                ],
                "min",
            )};
    `,
});

productCompareFlyOutStyles.carousel = mergeToNew(productCompareFlyOutStyles.carousel, {
    prevArrowButton: {
        variant: "primary",
        color: "text.link",
        css: css`
            border-radius: 50%;
            width: 40px;
            height: 40px;
            padding: 0;
            &:focus {
                outline: none;
            }
        `,
    },
    nextArrowButton: {
        variant: "primary",
        color: "text.link",
        css: css`
            border-radius: 50%;
            width: 40px;
            height: 40px;
            padding: 0;
            &:focus {
                outline: none;
            }
        `,
    },
});

productCompareFlyOutStyles.removeProductFromCompareButton = mergeToNew(
    productCompareFlyOutStyles.removeProductFromCompareButton,
    {
        color: "secondary",
    },
);
